<template>
    <v-content class="page_chisei">
        <ChiseiBody/>
    </v-content>
</template>

<script>
    import ChiseiBody from "@/components/Chisei_body";
    import {mapGetters} from "vuex";

    export default {
        name: "chisei",
        components: {
            ChiseiBody,
        },
        computed: {
            ...mapGetters({
                'getCustomerTypeTrk': 'params/getCustomerTypeTrk',
            }),
        },
        data() {
            return {
                idSession: sessionStorage.getItem('sessionId'),
            };
        },
        beforeMount(){
            window['tc_vars'] = {
                env_template: "AXA_PerNoi",
                env_work: process.env.VUE_APP_TRK_ENV,
                env_channel: channel,
                user_category: this.getCustomerTypeTrk,
                page_name: "Chi Sei",
                user_id: sessionStorage.getItem('sessionId'),
            };
        },
        head: {
            script: [
                {
                    type: 'text/javascript',
                    src: process.env.VUE_APP_URL_AXA1,
                },
                {
                    type: 'text/javascript',
                    inner: 'if (typeof tc_events_global === "function") { \n' +
                           '    tc_events_global(this, "virtual_page", {});\n' +
                           '}'
                },
            ],
            noscript: [{
                src: '//redirect4708.tagcommander.com/utils/noscript.php?id=1&amp;amp;mode=iframe',
                width: '1',
                height: '1',
                rel: 'noindex,nofollow',
            }],
        },
    };
</script>
